<template>
  <b-card class="border-0 ml-0 col-md-10 col-lg-10 col-sm-12">
    <p>
      By default, all email addresses receive mails from the test server. You can restrict this using the box below.
      <ul>
        <li>Please specify the e-mail addresses that <b>should</b> receive e-mails from the test server.</li>
        <li>Use one new line for each e-mail address.</li>
        <li>Addresses not specified below will <b>not</b> receive e-mails from the test server.</li>
      </ul>
    </p>
    <p>
      <b>PLEASE NOTE: </b>This setting must be made on the test server, not on the live server
    </p>
    <b-form-group label="E-mail addresses">
        <b-form-textarea 
          v-model="addresses"
          rows="10"
        ></b-form-textarea>
      </b-form-group>
      <div class="form-group col-12 mt-4">
        <b-button 
          @click.prevent="data_save" 
          class="mt-10"
          variant="primary"
        >
          Save Mail Addresses
        </b-button>
      </div>      
  </b-card>
</template>
<script>
const syspref_key = 'test_emails';

export default {
  created() {
    this.data_get()
  },
  data() {
    return {
      addresses: '',
    }
  },
  methods: {
    data_get() {
      this.addresses = '';
      this.$store.dispatch('syspref_fetch', { key: syspref_key })
      .then((res) => {
        if (res.data != "") {
          let dataarray = JSON.parse(res.data.value)
          this.addresses = dataarray.join('\n');
        }
      })     
    },
    data_save() {
      const newaddresses = this.addresses.split("\n").filter( f => f != '');
      this.$store.dispatch('syspref_save', { key: syspref_key,value: JSON.stringify(newaddresses) })
      .then( () => this.data_get());
    },
  }
}
</script>
<style>
</style>